/* Vogue Bazaar — pages.js
   Behaviour for content-page sections: hero word reveal, stat counters, FAQ,
   shop-the-look hotspots, coupon copy, size-guide tabs/units, brand directory. */
(function () {
  'use strict';
  const T = window.theme || {};
  const S = T.motion || {};
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motionOn = S.enabled !== false && !reduced;
  const drawerMode = () => !!(S.cartType === 'drawer' && document.getElementById('CartDrawer'));
  const fmt = n => n.toLocaleString(document.documentElement.lang || 'en');

  /* ---------- page hero: word-by-word entrance ---------- */
  $$('.phero__title[data-split]').forEach(h => {
    if (!motionOn) return;
    const words = h.textContent.trim().split(/\s+/);
    h.textContent = '';
    words.forEach((w, i) => { const s = document.createElement('span'); s.className = 'w'; s.style.setProperty('--i', i); s.textContent = w; h.append(s, ' '); });
  });

  /* ---------- stat counters ---------- */
  const counters = $$('[data-counter]');
  const finish = el => { const v = parseFloat(el.dataset.counter) || 0; const dec = (String(el.dataset.counter).split('.')[1] || '').length; el.textContent = dec ? v.toFixed(dec) : fmt(v); };
  const run = el => {
    const end = parseFloat(el.dataset.counter) || 0, dec = (String(el.dataset.counter).split('.')[1] || '').length, dur = 1500, t0 = performance.now();
    const step = now => {
      const p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3), v = end * e;
      el.textContent = dec ? v.toFixed(dec) : fmt(Math.round(v));
      if (p < 1) requestAnimationFrame(step); else finish(el);
    };
    requestAnimationFrame(step);
  };
  if (counters.length) {
    if (!motionOn || !('IntersectionObserver' in window)) counters.forEach(finish);
    else {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: 0.4 });
      counters.forEach(el => io.observe(el));
      setTimeout(() => counters.forEach(el => { const r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0 && el.textContent === '0') { run(el); io.unobserve(el); } }), 1500);
    }
  }

  /* ---------- FAQ accordion + search ---------- */
  $$('[data-faq]').forEach(box => {
    const items = $$('.faq__item', box), single = box.dataset.single !== 'false';
    items.forEach(it => {
      const q = $('.faq__q', it); if (!q) return;
      q.addEventListener('click', () => {
        const open = it.classList.contains('is-open');
        if (single) items.forEach(o => { o.classList.remove('is-open'); const oq = $('.faq__q', o); if (oq) oq.setAttribute('aria-expanded', 'false'); });
        it.classList.toggle('is-open', !open); q.setAttribute('aria-expanded', String(!open));
      });
    });
    const search = $('[data-faq-search]', box), empty = $('[data-faq-empty]', box);
    if (search) search.addEventListener('input', () => {
      const v = search.value.trim().toLowerCase(); let n = 0;
      items.forEach(it => { const hit = !v || it.textContent.toLowerCase().includes(v); it.hidden = !hit; if (hit) n++; });
      if (empty) empty.hidden = n > 0;
    });
  });

  /* ---------- shop the look: hotspots ---------- */
  $$('[data-look]').forEach(look => {
    const spots = $$('.hotspot', look), items = $$('.look__item', look), card = $('.hotspot__card', look);
    const show = i => {
      spots.forEach((s, k) => s.classList.toggle('is-active', k === i));
      items.forEach((it, k) => it.classList.toggle('is-active', k === i));
      if (!card) return;
      if (i < 0 || !spots[i]) { card.classList.remove('is-open'); return; }
      const d = spots[i].dataset;
      const img = $('img', card); if (img) { if (d.image) img.src = d.image; else img.removeAttribute('src'); }
      const set = (sel, v) => { const el = $(sel, card); if (el) el.textContent = v || ''; };
      set('.v', d.vendor); set('.t', d.title); set('.p', d.price);
      const go = $('a.go', card); if (go) go.href = d.url || '#';
      const add = $('[data-look-add]', card); if (add) { add.hidden = !d.variant; add.dataset.variant = d.variant || ''; }
      const x = parseFloat(d.x) || 50, y = parseFloat(d.y) || 50;
      if (x < 50) { card.style.left = `calc(${x}% + 26px)`; card.style.right = 'auto'; } else { card.style.right = `calc(${100 - x}% + 26px)`; card.style.left = 'auto'; }
      card.style.top = `min(max(12px, calc(${y}% - 50px)), calc(100% - 112px))`;
      card.classList.add('is-open');
    };
    spots.forEach((s, i) => s.addEventListener('click', e => { e.stopPropagation(); show(s.classList.contains('is-active') ? -1 : i); }));
    items.forEach((it, i) => it.addEventListener('pointerenter', () => show(i)));
    document.addEventListener('click', e => { if (!look.contains(e.target)) show(-1); });
    if (card) card.addEventListener('click', e => e.stopPropagation());
    const add = card && $('[data-look-add]', card);
    if (add) add.addEventListener('click', async () => {
      const id = parseInt(add.dataset.variant || '0', 10);
      if (!id || !T.cartAdd) return;
      add.disabled = true;
      try { await T.cartAdd(id, 1, $('img', card)); if (!drawerMode() && T.toast) T.toast(T.strings.added, T.strings.goToBag, T.routes.cart); }
      catch (err) { if (T.toast) T.toast(err.message || 'Could not add to bag'); }
      add.disabled = false;
    });
  });

  /* ---------- coupons: copy code ---------- */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-copy]'); if (!b) return;
    const code = b.dataset.copy;
    try { await navigator.clipboard.writeText(code); }
    catch (err) { const ta = document.createElement('textarea'); ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.append(ta); ta.select(); try { document.execCommand('copy'); } catch (e2) { /* noop */ } ta.remove(); }
    const old = b.textContent;
    b.textContent = b.dataset.copied || 'Copied!'; b.classList.add('is-copied');
    setTimeout(() => { b.textContent = old; b.classList.remove('is-copied'); }, 1600);
  });

  /* ---------- size guide: tabs + unit toggle ---------- */
  $$('[data-sizeguide]').forEach(sg => {
    const tabs = $$('.sg__tab', sg), panels = $$('.sg__panel', sg), ink = $('.sg__ink', sg);
    let unit = 'cm';
    const current = () => tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
    const moveInk = t => { if (!ink || !t) return; ink.style.setProperty('--l', t.offsetLeft + 'px'); ink.style.setProperty('--w', t.offsetWidth + 'px'); };
    const select = i => {
      tabs.forEach((t, k) => t.setAttribute('aria-selected', String(k === i)));
      panels.forEach((p, k) => p.classList.toggle('is-active', k === i));
      moveInk(tabs[i]);
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => select(i)));
    $$('[data-unit]', sg).forEach(b => b.addEventListener('click', () => {
      if (b.dataset.unit === unit) return;
      unit = b.dataset.unit;
      $$('[data-unit]', sg).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      $$('td[data-cm]', sg).forEach(td => {
        const cm = parseFloat(td.dataset.cm); if (isNaN(cm)) return;
        td.textContent = unit === 'cm' ? td.dataset.cm : String(Math.round(cm / 2.54 * 10) / 10);
        td.classList.remove('is-flip'); void td.offsetWidth; td.classList.add('is-flip');
      });
      $$('[data-unit-label]', sg).forEach(l => l.textContent = unit);
    }));
    if (tabs.length) { select(0); setTimeout(() => moveInk(current()), 60); window.addEventListener('load', () => moveInk(current())); window.addEventListener('resize', () => moveInk(current())); }
  });

  /* ---------- brand directory: search, letter nav, current letter ---------- */
  $$('[data-brands]').forEach(bd => {
    const groups = $$('.bd__group', bd), letters = $$('.bd__letter', bd), input = $('[data-brand-search]', bd), empty = $('[data-brand-empty]', bd), count = $('[data-brand-count]', bd);
    const apply = () => {
      const v = (input ? input.value : '').trim().toLowerCase(); let total = 0;
      groups.forEach(g => {
        let n = 0;
        $$('a', g).forEach(a => { const hit = !v || a.textContent.toLowerCase().includes(v); a.classList.toggle('is-hidden', !hit); if (hit) n++; });
        g.classList.toggle('is-hidden', n === 0); total += n;
      });
      if (empty) empty.hidden = total > 0;
      if (count) count.textContent = String(total);
    };
    if (input) input.addEventListener('input', apply);
    letters.forEach(l => l.addEventListener('click', () => {
      const g = groups.find(x => x.dataset.group === l.dataset.letter);
      if (g) g.scrollIntoView({ behavior: motionOn ? 'smooth' : 'auto', block: 'start' });
    }));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) letters.forEach(l => l.classList.toggle('is-current', l.dataset.letter === e.target.dataset.group)); }), { rootMargin: '-15% 0px -75% 0px' });
      groups.forEach(g => io.observe(g));
    }
    apply();
  });
})();
